// controllers/active_link_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  activate(event) {
    this.linkTargets.forEach(l => l.classList.remove("active"));
    event.currentTarget.classList.add("active");
  }
}
